import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Route, Router } from '@angular/router';

@Component({
  selector: 'app-md-calculator',
  templateUrl: './md-calculator.component.html',
  styleUrls: ['./md-calculator.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MdCalculatorComponent {

  calculatorDataChildren: Route[] = [];

  constructor(private router: Router) { }

  ngOnInit(): void {
    // Find the master-data route first
    const masterDataRoute = this.router.config.find(r => r.path === 'master-data');

    // Then find the 'other' child route within master-data
    const otherRoute = masterDataRoute?.children?.find(child => child.path === 'cnf-calculator');

    // Get the third-level children (auction-hall, documents, etc.)
    this.calculatorDataChildren = otherRoute?.children ?? [];
  }
}
